module.exports = __webpack_public_path__ + "img/Pearl.1b798f76.png";